export const MOBILE_ERR = "Enter a valid 10-digit mobile number.";

// Mirrors backend crm.normalize_mobile: "" when blank, null when invalid, else 10 digits. Never truncates.
export function normalizeMobile(raw) {
  const s = String(raw ?? "").trim();
  if (!s) return "";
  if (!/^\+?[\d\s\-()]+$/.test(s)) return null;
  let d = s.replace(/\D/g, "");
  if (s.startsWith("+")) {
    if (!d.startsWith("91")) return null;
    d = d.slice(2);
  } else if (d.length === 14 && d.startsWith("0091")) d = d.slice(4);
  else if (d.length === 12 && d.startsWith("91")) d = d.slice(2);
  else if (d.length === 11 && d.startsWith("0")) d = d.slice(1);
  return /^[6-9]\d{9}$/.test(d) ? d : null;
}

// required: blank is an error. allowBlank (editing a customer who never had a number) keeps blank valid.
export const mobileError = (raw, { allowBlank = false } = {}) => {
  const n = normalizeMobile(raw);
  if (n === null) return MOBILE_ERR;
  if (n === "" && !allowBlank) return MOBILE_ERR;
  return "";
};

export const todayISO = () => new Date(Date.now() + 330 * 60000).toISOString().slice(0, 10);

// DOB / adoption: optional, not in the future, adoption on/after birth.
export function petDateErrors(v) {
  const t = todayISO(), e = {};
  if (v.dob && v.dob > t) e.dob = "Date of birth cannot be in the future";
  if (v.adoption_date && v.adoption_date > t) e.adoption_date = "Adoption date cannot be in the future";
  if (!e.adoption_date && v.dob && v.adoption_date && v.adoption_date < v.dob) e.adoption_date = "Adoption date cannot be before the date of birth";
  return e;
}

export function petAge(dob) {
  if (!dob) return "";
  const d = new Date(dob);
  if (Number.isNaN(d.getTime())) return "";
  const n = new Date();
  let m = (n.getFullYear() - d.getFullYear()) * 12 + (n.getMonth() - d.getMonth());
  if (n.getDate() < d.getDate()) m -= 1;
  if (m < 0) return "";
  return m < 12 ? `${m} mo` : `${Math.floor(m / 12)} yr${m >= 24 ? "s" : ""}${m % 12 ? ` ${m % 12} mo` : ""}`;
}
